import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { apiGet, apiPost } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { BsArrowsMove } from 'react-icons/bs'
import { useLocation, useNavigate } from 'react-router-dom'
import useToastContext from 'hooks/useToastContext'
import OSelect from 'components/reusable/OSelect'

export default function PropertyCategorySequence () {
  const { t } = useTranslation()
  const notification = useToastContext()
  const location = useLocation()
  const navigate = useNavigate()
  const pageSize = location.state || {}
  const [subcategoryList, setSubcategoryList] = useState([])
  const [categoryList, setCategoryList] = useState([])
  const [category, setCategory] = useState()
  const [isChange, setIsChange] = useState(false)

  const allSubCategory = async () => {
    try {
      var path = apiPath.propertyCategoryList
      const payload = {
        page_size: pageSize?.page_size,
        status: 'active',
        sortKey: 'sequence',
        sortType: 'asc',
        propertyTypeId: category
      }
      const result = await apiGet(path, payload)
      var response = result?.data?.results
      const dragIdResponse = response?.docs.map((element, index) => {
        return { ...element, id: `${index}` }
      })
      setSubcategoryList(dragIdResponse)
    } catch (err) {
      console.log(err)
    }
  }
  const allCategory = async payload => {
    try {
      const path = apiPath.listPropertyType
      const result = await apiGet(path, payload)
      if (result?.data?.success) {
        const response = result?.data?.results
        const categoriesList = response?.map(item => {
          return { key: item?.name, value: item?._id, keyAr: item?.nameAr }
        })
        setCategoryList(categoriesList)
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  const sequenceSort = async payload => {
    try {
      const sequence = payload?.map(element => {
        return {
          _id: element._id,
          sequence: element.sequence
        }
      })
      const result = await apiPost(apiPath.updateSequence, {
        sequence: sequence
      })
      notification.success(result?.data?.message)
      navigate(-1)
    } catch (err) {
      console.log(err)
    }
  }
  const onDragEnd = result => {
    if (!result.destination) return

    const updatedItems = [...subcategoryList]
    const [movedItem] = updatedItems.splice(result.source.index, 1)
    updatedItems.splice(result.destination.index, 0, movedItem)
    const updatedSequence = updatedItems.map((element, index) => {
      return { ...element, sequence: index }
    })
    setIsChange(true)
    setSubcategoryList(updatedSequence)
  }

  useEffect(() => {
    allSubCategory()
  }, [category])

  useEffect(() => {
    allCategory()
  }, [])

  return (
    <>
      <div>
        <div className='2xl:ml-auto xl:ml-0 lg:pt-0 pt-2'>
          <div className='flex mt-4 ml-4 items-center'>
            <button
              className='mb-6 text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-2  ease-linear transition-all duration-150'
              type='button'
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            <button
              title='Add Property Category'
              type='button'
              className={
                isChange
                  ? 'mb-6 bg-[#8FC150] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                  : 'mb-6 bg-[#E1E1E1] flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-black hover:bg-[#E1E1E1] whitespace-nowrap cursor-not-allowed'
              }
              onClick={() => isChange && sequenceSort(subcategoryList)}
            >
              Update
            </button>
            <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
              <OSelect
                wrapperClassName='relative z-0 mb-6 w-full group'
                name='propertyTypeId'
                onClick={e => setCategory(e.target.value)}
                type='select'
                options={categoryList}
                removeDefault={true}
              />
            </div>
          </div>
        </div>
        <div className='p-3'>
          {subcategoryList?.length > 0 && (
            <div className='overflow-x-auto relative 
 border'>
              <DragDropContext onDragEnd={onDragEnd}>
                <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
                  <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
                    <tr>
                      <th scope='col' className='py-3 px-6'>
                        <div className='text-left'>{t('Drag Row')}</div>
                      </th>
                      <th scope='col' className='py-3 px-6 text-center'>
                        #
                      </th>
                      <th scope='col' className='py-3 px-6'>
                        {t('PROPERTY_TYPE')}
                      </th>

                      <th scope='col' className='py-3 px-6'>
                        {t('O_NAME')}
                      </th>
                      <th scope='col' className='py-3 px-6'>
                        {t('O_NAME') + t('O_ARABIC')}
                      </th>
                    </tr>
                  </thead>

                  <Droppable droppableId='item-list1' type='droppableItem'>
                    {provided => (
                      <tbody
                        ref={provided?.innerRef}
                        {...provided?.droppableProps}
                      >
                        {subcategoryList &&
                          subcategoryList?.map((item, i) => (
                              <Draggable
                                key={item?.id}
                                draggableId={item?.id}
                                index={i}
                              >
                                {provided => (
                                  <tr
                                    key={i}
                                    className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                                    ref={provided?.innerRef}
                                    {...provided?.draggableProps}
                                    {...provided?.dragHandleProps}
                                  >
                                    <td className='py-2 px-2 border-r h-4 w-4'>
                                      <BsArrowsMove />
                                    </td>
                                    <th
                                      scope='row'
                                      className='py-2 px-2 text-center border-r font-medium text-gray-900  dark:text-white'
                                    >
                                      {i + 1}
                                    </th>
                                    <td className='py-2 px-2 border-r'>
                                      {item?.propertyType?.name}
                                    </td>
                                    <td className='py-2 px-2 border-r'>
                                      {item?.name}
                                    </td>
                                    <td className='py-2 px-2 border-r'>
                                      {item?.nameAr}
                                    </td>
                                  </tr>
                                )}
                              </Draggable>
                            ))}
                      </tbody>
                    )}
                  </Droppable>
                </table>
              </DragDropContext>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
